import React from 'react';
import { TopBar } from '../components/TopBar';
import { WebinarHero } from '../components/WebinarHero';
import { WhatYouLearn } from '../components/WhatYouLearn';
import { SocialProof } from '../components/SocialProof';
import { WebinarFooter } from '../components/WebinarFooter';
import { motion } from 'framer-motion';
import { LeadCaptureForm } from '../components/LeadCaptureForm';
export function WebinarPage() {
  return <div style={{
    background: 'var(--bg-deep)',
    minHeight: '100vh',
    width: '100%'
  }} data-id="element-202">
      <TopBar data-id="element-203" />
      <main data-id="element-204">
        <WebinarHero data-id="element-205" />
        <WhatYouLearn data-id="element-206" />
        <SocialProof data-id="element-207" />

        {/* Final CTA Section */}
        <section style={{
        background: 'linear-gradient(135deg, #1a0030 0%, #0a0a0f 50%, #001a1a 100%)',
        padding: '64px 16px',
        position: 'relative',
        overflow: 'hidden'
      }} data-id="element-208">
          {/* Glow blobs */}
          <div style={{
          position: 'absolute',
          top: '20%',
          left: '10%',
          width: '500px',
          height: '300px',
          background: 'radial-gradient(ellipse, rgba(105,0,175,0.12) 0%, transparent 70%)',
          pointerEvents: 'none'
        }} data-id="element-209" />
          <div style={{
          position: 'absolute',
          bottom: '10%',
          right: '10%',
          width: '400px',
          height: '300px',
          background: 'radial-gradient(ellipse, rgba(0,242,234,0.08) 0%, transparent 70%)',
          pointerEvents: 'none'
        }} data-id="element-210" />

          <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1,
          textAlign: 'center'
        }} data-id="element-211">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-212">
              {/* Urgency badge */}
              <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(255,226,34,0.1)',
              border: '1px solid rgba(255,226,34,0.3)',
              borderRadius: '100px',
              padding: '8px 18px',
              marginBottom: '24px'
            }} data-id="element-213">
                <span style={{
                color: 'var(--color-yellow)',
                fontSize: '14px',
                fontWeight: 700,
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-214">
                  ⏰ Acceso gratuito disponible por tiempo limitado
                </span>
              </div>

              <h2 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(28px, 4.5vw, 50px)',
              color: 'white',
              marginBottom: '16px',
              letterSpacing: '-0.02em',
              lineHeight: 1.15
            }} data-id="element-215">
                ¿Listo para Convertirte en{' '}
                <span className="text-gradient-cyan-magenta" data-id="element-216">
                  Afiliado Pro de TikTok Shop?
                </span>
              </h2>

              <p style={{
              color: '#a0a0b0',
              fontSize: '17px',
              fontFamily: 'Inter, sans-serif',
              lineHeight: 1.7,
              marginBottom: '48px',
              maxWidth: '560px',
              margin: '0 auto 48px'
            }} data-id="element-217">
                Únete a más de{' '}
                <strong style={{
                color: 'white'
              }} data-id="element-218">
                  2,400 estudiantes
                </strong>{' '}
                que ya aplican este sistema para promocionar productos de
                terceros, generar{' '}
                <strong style={{
                color: 'white'
              }} data-id="element-219">
                  comisiones diarias
                </strong>{' '}
                y escalar su cuenta de forma orgánica{' '}
                <strong style={{
                color: 'white'
              }} data-id="element-220">
                  sin invertir en inventario ni publicidad.
                </strong>
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} style={{
            display: 'flex',
            justifyContent: 'center'
          }} data-id="element-221">
              <LeadCaptureForm data-id="element-222" />
            </motion.div>
          </div>
        </section>
      </main>
      <WebinarFooter data-id="element-223" />
    </div>;
}